import React, { Component } from 'react';
import { connect } from "react-redux";
import { Container, Row, Button } from 'reactstrap';
import i18n from "../../../../i18next";
import MaterialIcon from "material-icons-react";

import { loadOpeningHours, saveOpeningHours } from "../../../../actions";
import TimeTableScreen from '../../../common/operationHours/TimeTableScreen';

class OpeningHoursScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            restaurantOpeningHours: [],
            openingHours: [],
            showErrorMsg: false,
            stateAlreadyCopiedFromProps: false,
        }

        this.saveOpeningHours = this.saveOpeningHours.bind(this);
        this.updatePrepTimesState = this.updatePrepTimesState.bind(this);
    }

    componentWillMount() {
        const { id } = this.props.match.params;

        this.props.loadOpeningHours(id);
    }

    copyStateFromProps() {
        const { restaurantOpeningHours } = this.props;

        if (restaurantOpeningHours !== undefined && restaurantOpeningHours !== null
            && restaurantOpeningHours.length > 0 && !this.state.stateAlreadyCopiedFromProps) {

            this.setState({
                restaurantOpeningHours: restaurantOpeningHours,
                stateAlreadyCopiedFromProps: true
            });
        }
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.restaurantOpeningHours !== this.props.restaurantOpeningHours) {
            this.copyStateFromProps();
        }
    }

    /* Data Manipulation Functions */
    updateRestaurantHours(target, dayId) {
        let updatedRestaurantOpeningHours = [];

        this.state.restaurantOpeningHours.map((item) => {
            const currentOpeningHours = {
                id: item.id,
                day: item.day,
                openHour: item.openHour,
                openMinute: item.openMinute,
                closeHour: item.closeHour,
                closeMinute: item.closeMinute,
            };

            if (currentOpeningHours.id === dayId) {
                if (target.value === undefined || target.value === null || target.value === '') {
                    currentOpeningHours[target.name] = '';
                } else {
                    currentOpeningHours[target.name] = Number(target.value);
                }
            }

            updatedRestaurantOpeningHours.push(currentOpeningHours);
        });

        return updatedRestaurantOpeningHours;
    }

    prepareOpeningHoursForSave() {
        let updatedRestaurantOpeningHours = [];
        // Set restaurant hour/minute to null on condition - else set it to a number
        this.state.restaurantOpeningHours.map((item) => {
            const currentOpeningHours = {
                id: item.id,
                day: item.day,
                openHour: item.openHour,
                openMinute: item.openMinute,
                closeHour: item.closeHour,
                closeMinute: item.closeMinute,
            };

            if (currentOpeningHours.openHour === '' || currentOpeningHours.openHour === '0' || currentOpeningHours.openHour === null) {
                currentOpeningHours.openHour = null;
            } else {
                currentOpeningHours.openHour = Number(item.openHour);
            }

            if (currentOpeningHours.openMinute === '' || currentOpeningHours.openMinute === '0' || currentOpeningHours.openMinute === null) {
                currentOpeningHours.openMinute = null;
            } else {
                currentOpeningHours.openMinute = Number(item.openMinute);
            }

            if (currentOpeningHours.closeHour === '' || currentOpeningHours.closeHour === '0' || currentOpeningHours.closeHour === null) {
                currentOpeningHours.closeHour = null;
            } else {
                currentOpeningHours.closeHour = Number(item.closeHour);
            }

            if (currentOpeningHours.closeMinute === '' || currentOpeningHours.closeMinute === '0' || currentOpeningHours.closeMinute === null) {
                currentOpeningHours.closeMinute = null;
            } else {
                currentOpeningHours.closeMinute = Number(item.closeMinute);
            }

            updatedRestaurantOpeningHours.push(currentOpeningHours);
        });

        return updatedRestaurantOpeningHours;
    }

    /* Component Event Handlers */
    changeState({ target }) {
        if (isNaN(target.value)) {
            return;
        }

        const dayId = Number(target.id);

        let updatedRestaurantOpeningHours = this.updateRestaurantHours(target, dayId);

        this.setState({
            ...this.state,
            restaurantOpeningHours: updatedRestaurantOpeningHours
        });
    }
    /* Component Save Methods */
    saveOpeningHours() {
        const { id } = this.props.match.params;
        const callback = this.setState({
            ...this.state,
            showErrorMsg: false
        });
        // let restaurantOpeningHours = this.prepareOpeningHoursForSave();
        this.props.saveOpeningHours(this.state.restaurantOpeningHours, id, callback);
    }

    /* Component Render Methods */
    renderHeading() {
        const { screenHeading } = styles;

        return (
            <div style={screenHeading}>
                <div><MaterialIcon icon="schedule" size={20} color="#0288d1" />&nbsp;
                {i18n.t('screens:daysOffModal.openingHoursLabel')}</div>
            </div>
        );
    }

    renderSaveButton() {
        const { buttonFloatRight, spaceBetween } = styles;

        return (
            <Button style={buttonFloatRight} color="primary" onClick={this.saveOpeningHours} >
                <MaterialIcon icon="save" color="#fff" size={18} />
                <span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
            </Button>
        );
    }

    renderTimePeriods() {
        return (
            <TimeTableScreen
                preparationTimes={this.state.restaurantOpeningHours}
                updatePrepTimes={this.updatePrepTimesState}
                showErrorMsg={this.state.showErrorMsg} />
        );
    }

    updatePrepTimesState(prepTimes, showErrorMsg) {
        this.setState({
            ...this.state,
            restaurantOpeningHours: prepTimes,
            showErrorMsg: showErrorMsg
        });
    }

    render() {
        const { containerStyle } = styles;

        // this.copyStateFromProps(this.state.restaurantOpeningHours);

        return (
            <Container fluid style={containerStyle}>
                <Row>{this.renderHeading()}</Row>
                {this.renderTimePeriods()}
                {this.renderSaveButton()}
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        restaurant: state.restaurant,
        restaurantOpeningHours: state.restaurantOpeningHours
    };
};

export default connect(mapStateToProps, { loadOpeningHours, saveOpeningHours })(OpeningHoursScreen);

let styles = {
    containerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        paddingTop: 10
    },
    posAsyncTimeInput: {
        width: 80,
        float: 'left',
        marginRight: 5
    },
    buttonFloatRight: {
        float: 'right',
        marginRight: -15,
        marginTop: 10,
        marginBottom: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    spaceBetween: {
        paddingLeft: 4
    },
    paragraph: {
        fontSize: 14,
        display: "flex",
        justifyContent: 'flex-end',
        marginBottom: 5
    },
    paragraphLast: {
        fontSize: 14,
        display: "flex",
        justifyContent: 'flex-end',
        marginBottom: 20
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/OpeningHoursScreen.js